export let IntegrationFailureCode = /*#__PURE__*/function (IntegrationFailureCode) {
  IntegrationFailureCode["Unknown"] = "unknown";
  IntegrationFailureCode["DuplicateDocumentNumberError"] = "duplicate_document_number_error";
  IntegrationFailureCode["AmountCalculationIncorrect"] = "amount_calculation_incorrect";
  IntegrationFailureCode["CustomerDeleted"] = "customer_deleted";
  IntegrationFailureCode["ItemDeleted"] = "item_deleted";
  IntegrationFailureCode["ClassDeleted"] = "class_deleted";
  IntegrationFailureCode["InvoiceAmountNotMatching"] = "invoice_amount_not_matching";
  IntegrationFailureCode["ObjectNotFound"] = "object_not_found";
  IntegrationFailureCode["AccountDeleted"] = "account_deleted";
  IntegrationFailureCode["VendorDeleted"] = "vendor_deleted";
  IntegrationFailureCode["InvoicePaid"] = "invoice_paid";
  IntegrationFailureCode["DepositTotalAmountNotMatching"] = "deposit_total_amount_not_matching";
  IntegrationFailureCode["TransactionCannotBeAppliedToDeposit"] = "transaction_cannot_be_applied_to_deposit";
  IntegrationFailureCode["InvoiceDeleted"] = "invoice_deleted";
  IntegrationFailureCode["PaymentDeleted"] = "payment_deleted";
  IntegrationFailureCode["AccountPeriodClosed"] = "account_period_closed";
  IntegrationFailureCode["InvalidCompanyStatus"] = "invalid_company_status";
  IntegrationFailureCode["MissingPermissions"] = "missing_permissions";
  IntegrationFailureCode["ClassTrackingDisabledWithOverride"] = "class_tracking_disabled_with_override";
  IntegrationFailureCode["ItemIsCategory"] = "item_is_category";
  IntegrationFailureCode["InvoiceClientNotMapped"] = "invoice_client_not_mapped";
  IntegrationFailureCode["InvoiceServiceNotMapped"] = "invoice_service_not_mapped";
  IntegrationFailureCode["InvoiceClientAndServiceNotMapped"] = "invoice_client_service_not_mapped";
  IntegrationFailureCode["PayoutTransactionsNotSynced"] = "payout_transactions_not_synced";
  return IntegrationFailureCode;
}({});
export class IntegrationFailureModel {
  static fromScoutDTO(date, customFailure) {
    return new IntegrationFailureModel({
      date,
      customFailure: {
        code: customFailure.code,
        param: customFailure.param,
        paramPendingSync: customFailure.paramPendingSync
      }
    });
  }
  constructor(data) {
    this.data = data;
  }
  failureCode() {
    return this.data.customFailure.code;
  }
  failureParam() {
    return this.data.customFailure.param;
  }
  invoicesAndPaymentsToSync() {
    const {
      paramPendingSync
    } = this.data.customFailure;
    return paramPendingSync ? paramPendingSync.invoicesToSync.concat(paramPendingSync.paymentsToSync) : [];
  }
  date() {
    return new Date(this.data.date);
  }
}